import styles from './Slider.module.scss';

const Slider = ({element}) => {
    const { slide } = element;
    return ( 
        <div className= {styles.container}>
        <img className={styles.photo} src={slide} alt='семейные, детские, свадебные фото Ставрополь'/>
</div> 
    );
}

export default Slider;